<div class="child" *ngFor="let subChild of child.subcategories; let k = index" lines="none"
class="child-list">
<div matRipple  (click)="productList(subChild , subChild.subcategories.length)" class="subchild itemLabel padding-10 padding-l50">
 <span class="itemLabel"> {{ subChild.categoryName }}</span>
</div>
<calsoft-nested-side-menu-child [child]="subChild"></calsoft-nested-side-menu-child>
</div>
